export enum NotificationsChannels {
  None = 'None',
  Common = 'Common',
  Mover = 'Mover',
  QuestionAddressApi = 'QuestionAddressApi',
  LeaveToLet = 'LeaveToLet',
  MortgageIncrease = 'MortgageIncrease'
}
